// Copy shared across the site: navigation, hero, footer, WhatsApp and system messages.
const common = {
  nav: {
    '/': 'Home',
    '/products': 'Products',
    '/uses': 'Grade Guide',
    '/how-we-work': 'How We Work',
    '/true-cinnamon': 'True Cinnamon',
    '/contact': 'Contact',
  },
  homeLinkLabel: 'Spice Yield home',
  menuToggle: 'Toggle menu',
  themeToLight: 'Switch to light mode',
  themeToDark: 'Switch to dark mode',
  languageSwitch: 'Language',

  whatsapp: {
    label: 'Chat with us on WhatsApp',
    defaultMessage: 'Hello! I\'m interested in your Ceylon Cinnamon products. Can you help me?',
    quoteMessage: 'Hello! I\'d like a quote for Ceylon cinnamon.\nGrade / use:\nQuantity:\nDestination:',
  },

  hero: {
    heading: 'Ceylon cinnamon exporter from Sri Lanka',
    slides: [
      {
        badge: 'Export grades',
        title: 'Every Grade, C5 to H3',
        subtitle: 'Quills, quillings, off cuts and cinnamon oil, packed to your specification.',
      },
      {
        badge: 'Cinnamomum verum',
        title: 'Ceylon Cinnamon',
        subtitle: 'True cinnamon from southern Sri Lanka, peeled and rolled by hand.',
      },
      {
        badge: 'From the source',
        title: 'Grown in Sri Lanka',
        subtitle: 'Cinnamon seedlings in our nursery, before they are planted out on the estate.',
      },
    ],
    viewProducts: 'View products',
    requestQuote: 'Request a quote',
    slideLabel: (n, title) => `Show slide ${n}: ${title}`,
  },

  // Certifications we hold, shown on Home and in the footer. Names stay as issued.
  certifications: {
    label: 'Certifications',
    exporter: 'EDB-registered exporter',
    items: [
      { name: 'Pure Ceylon Cinnamon', desc: 'EDB lion logo licence' },
      { name: 'Ceylon Cinnamon PGI', desc: 'EU geographical indication' },
      { name: 'Halal', desc: 'Halal certified' },
      { name: 'SLS 81', desc: 'Graded to the Sri Lankan standard' },
      { name: 'GMP', desc: 'Certified processing centre' },
      { name: 'ISO 22000', desc: 'Food safety management' },
      { name: 'BRCGS', desc: 'Global food safety standard' },
    ],
  },

  footer: {
    description: 'Ceylon cinnamon grown, peeled and graded in southern Sri Lanka, and exported to buyers worldwide.',
    ctaTitle: 'Ready for a quote?',
    ctaText: 'Tell us the grade, quantity and destination. We reply within one business day.',
    ctaButton: 'Request a quote',
    ctaWhatsapp: 'WhatsApp us',
    products: 'Products',
    company: 'Company',
    contact: 'Contact',
    // Footer product links, each jumping to its section of the Products page
    productLinks: {
      continental: 'Continental quills',
      hamburg: 'Hamburg quills',
      pieces: 'Quillings & off cuts',
      'other-products': 'Oil, pepper & arecanut',
    },
    sriLanka: 'Sri Lanka',
    singapore: 'Singapore',
    rights: 'All Rights Reserved.',
  },

  // Shown to visitors whose browser prefers Spanish while they're on the English site
  languageSuggestion: {
    text: '¿Prefiere leer en español?',
    action: 'Ver el sitio en español',
    dismiss: 'Cerrar',
  },

  notFound: {
    title: 'Page not found',
    text: 'The page you’re looking for doesn’t exist or has moved.',
    products: 'View products',
    home: 'Go to the home page',
  },

  error: {
    title: 'Something went wrong',
    text: 'This page hit a problem, sometimes caused by a browser translation tool. Reloading usually fixes it.',
    reload: 'Reload the page',
  },
};

export default common;
